 import ApiService from './ApiService.js';  
 const uuidv1 = require('uuid/v1');
 const querystring = require('querystring') 
 var DataSetService = { 
 
         findAll($data) { 
             return new Promise(function(resolve,reject) { 
             var $options= {}; 
             $options.url ='dataset' 
             $options.method='get' 
             if($data) { 
                 $options.url='dataset?'+ querystring.stringify($data) 
             } 
             ApiService.request($options) 
                 .then(response => {  
                     resolve(response.data.data) 
                 }).catch(error=> { 
                     reject(error);
                 }) 
             });
         }, 
         getColumns($data) {
            return new Promise(function(resolve,reject) { 
                var $options= {}; 
                $options.url ='dataSetColumns' 
                $options.method='get' 
                if($data) { 
                    $options.url='dataSetColumns/'+$data.id
                } 
                ApiService.request($options) 
                    .then(response => {  
                        resolve(response.data.data) 
                    }).catch(error=> { 
                        reject(error);
                    }) 
                });
         },
         getColumnsForReport($data) {
            return new Promise(function(resolve,reject) { 
                var $options= {}; 
                $options.url ='reportInfo' 
                $options.method='get' 
                if($data) { 
                    $options.url='reportInfo/'+$data.id
                } 
                ApiService.request($options) 
                    .then(response => {  
                        resolve(response.data.data) 
                    }).catch(error=> { 
                        reject(error);
                    }) 
                });
         },
         findOne($data) { 
             return new Promise(function(resolve,reject) { 
             var $options= {}; 
             $options.url ='dataset' 
             $options.method='get' 
             if($data) { 
                 $options.url='dataset/'+$data.id 
             } 
             ApiService.request($options) 
                 .then(response => {  
                     resolve(response.data.data) 
                 }).catch(error=> { 
                     reject(error);
                 }) 
             });
         }, 
         create($data) { 
             return new Promise(function(resolve,reject) { 
             var $options= {}; 
             $options.data=$data
             /*$options.data.id= $data.id;
             $options.data.name= $data.name;
             $options.data.data_source= $data.data_source; 
             $options.data.active= $data.active;
             $options.data.type= $data.type;
             $options.data.key_id= $data.key_id;
             $options.data.key_name= $data.key_name;*/
             $options.data.active=1
             $options.data.modified_by = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.id 
             $options.data.created_by = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.id   
             $options.data.company_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.company_id     
             $options.url ='dataset' 
             $options.method='post' 
             ApiService.request($options) 
                 .then(response => {  
                     resolve(response.data.data) 
                 }).catch(error=> { 
                     reject(error);
                 }) 
             });
         }, 
         update($data) { 
             return new Promise(function(resolve,reject) { 
             var $options= {}; 
             $options.data={};
             $options.data.id= $data.id;
             $options.data.name= $data.name;
             $options.data.data_source= $data.data_source; 
             $options.data.active= $data.active;
             $options.data.type= $data.type;
             $options.data.key_id= $data.key_id;
             $options.data.key_name= $data.key_name;
             $options.data.data_source= $data.data_source; 
             $options.data.modified_by = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.id 
             $options.data.created_by = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.id   
             $options.data.company_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.company_id     
             $options.method='post' 
             $options.url='DataSet/'+$data.id 
             ApiService.request($options) 
                 .then(response => {  
                     resolve(response.data.data) 
                 }).catch(error=> { 
                     reject(error);
                 }) 
             });
         } 
 

        
}; 
export default DataSetService;